import { useState } from "preact/hooks";
import type { FlowState } from "../flow/machine";
import type { InstallRunner } from "../flow/runner";
import { t } from "../i18n";
import { DeviceCard } from "./PreflightStep";

export function UnlockStep({ runner, s, connected }: { runner: InstallRunner; s: FlowState; connected: boolean }) {
  const [typed, setTyped] = useState("");
  const [oemDone, setOemDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const word = t("unlock.confirm_word");
  const ready = oemDone && typed.trim().toUpperCase() === word.toUpperCase() && connected;
  const go = async () => {
    setBusy(true);
    runner.confirmUnlock();
    await runner.unlock();
    setBusy(false);
  };
  return (
    <div class="panel">
      <h2 tabIndex={-1}>{t("unlock.heading")}</h2>
      <div class="notice danger">
        <h3>{t("unlock.warning_title")}</h3>
        <p>{t("unlock.warning_body")}</p>
      </div>
      <h3>{t("unlock.oem_heading")}</h3>
      <ol class="steps">
        <li>{t("unlock.oem1")}</li>
        <li>{t("unlock.oem2")}</li>
        <li>{t("unlock.oem3")}</li>
        <li>{t("unlock.oem4")}</li>
      </ol>
      <label style="font-weight:400">
        <input type="checkbox" checked={oemDone} onChange={(e) => setOemDone((e.target as HTMLInputElement).checked)} /> {t("unlock.oem_done")}
      </label>
      <div style="margin-top:1rem">
        <label for="confirm-erase">{t("unlock.confirm_label", { word })}</label>
        <input id="confirm-erase" class="ltr" type="text" autocomplete="off" value={typed} onInput={(e) => setTyped((e.target as HTMLInputElement).value)} aria-describedby="confirm-hint" />
        <p id="confirm-hint" class="hint">{t("unlock.on_phone")}</p>
      </div>
      {!connected && <p class="notice warn">{t("preflight.reconnect_hint")} <button type="button" class="link" onClick={() => void runner.reconnect()}>{t("preflight.reconnect")}</button></p>}
      <div class="row">
        <button type="button" class="danger" disabled={!ready || busy} onClick={() => void go()}>{busy ? t("unlock.waiting") : t("unlock.button")}</button>
      </div>
      <DeviceCard s={s} />
    </div>
  );
}
